module.exports = "https://r.nearpod.com/assets/media/image/placeholder-waveform-ebdc86265ac76104ac0b91d17dc45267.svg";